import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import HomePage from "@/pages/HomePage";
import SermonsPage from "@/pages/SermonsPage";
import GivePage from "@/pages/GivePage";
import GiveSuccessPage from "@/pages/GiveSuccessPage";
import PrayerPage from "@/pages/PrayerPage";
import EventsPage from "@/pages/EventsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PlanVisitPage from "@/pages/PlanVisitPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <div className="App">
          <Toaster position="top-center" richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/sermons" element={<SermonsPage />} />
              <Route path="/give" element={<GivePage />} />
              <Route path="/give/success" element={<GiveSuccessPage />} />
              <Route path="/prayer" element={<PrayerPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/visit" element={<PlanVisitPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </div>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
